/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../eigen_lcm/Vector3d";
import {
  GimbalOrientationMode_Enum,
  gimbalOrientationMode_EnumFromJSON,
  gimbalOrientationMode_EnumToJSON,
} from "./gimbal_orientation_mode";
import { GimbalRollCommand } from "./gimbal_roll_command";
import {
  MovementCommandSource_Enum,
  movementCommandSource_EnumFromJSON,
  movementCommandSource_EnumToJSON,
} from "./movement_command_source";
import { SpatialWaypointsCommand } from "./spatial_waypoints_command";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Movement {
  utime: number;
  source: MovementCommandSource_Enum;
  sourceUtime: number;
  position: Vector3dPb | undefined;
  positionAggressiveness: number;
  velocity: Vector3dPb | undefined;
  velocityAggressiveness: number;
  maxSpeed: number;
  posVelFrame: number;
  heading: number;
  headingSmoothness: number;
  headingAggressiveness: number;
  headingRate: number;
  headingRateAggressiveness: number;
  maxHeadingRate: number;
  gimbalPitch: number;
  gimbalPitchSmoothness: number;
  gimbalPitchAggressiveness: number;
  gimbalPitchRate: number;
  gimbalPitchRateAggressiveness: number;
  maxGimbalPitchRate: number;
  gimbalRollCommand: GimbalRollCommand | undefined;
  enforceLookatSmoothness: boolean;
  height: number;
  heightAggressiveness: number;
  spatialWaypointsEnable: boolean;
  spatialWaypointsCommand: SpatialWaypointsCommand | undefined;
  overridePrecisionFlight: boolean;
  gimbalOrientationMode: GimbalOrientationMode_Enum;
}

function createBaseMovement(): Movement {
  return {
    utime: 0,
    source: 0,
    sourceUtime: 0,
    position: undefined,
    positionAggressiveness: 0,
    velocity: undefined,
    velocityAggressiveness: 0,
    maxSpeed: 0,
    posVelFrame: 0,
    heading: 0,
    headingSmoothness: 0,
    headingAggressiveness: 0,
    headingRate: 0,
    headingRateAggressiveness: 0,
    maxHeadingRate: 0,
    gimbalPitch: 0,
    gimbalPitchSmoothness: 0,
    gimbalPitchAggressiveness: 0,
    gimbalPitchRate: 0,
    gimbalPitchRateAggressiveness: 0,
    maxGimbalPitchRate: 0,
    gimbalRollCommand: undefined,
    enforceLookatSmoothness: false,
    height: 0,
    heightAggressiveness: 0,
    spatialWaypointsEnable: false,
    spatialWaypointsCommand: undefined,
    overridePrecisionFlight: false,
    gimbalOrientationMode: 0,
  };
}

export const Movement = {
  encode(message: Movement, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.source !== 0) {
      writer.uint32(16).int32(message.source);
    }
    if (message.sourceUtime !== 0) {
      writer.uint32(24).sint64(message.sourceUtime);
    }
    if (message.position !== undefined) {
      Vector3dPb.encode(message.position, writer.uint32(34).fork()).ldelim();
    }
    if (message.positionAggressiveness !== 0) {
      writer.uint32(45).float(message.positionAggressiveness);
    }
    if (message.velocity !== undefined) {
      Vector3dPb.encode(message.velocity, writer.uint32(50).fork()).ldelim();
    }
    if (message.velocityAggressiveness !== 0) {
      writer.uint32(61).float(message.velocityAggressiveness);
    }
    if (message.maxSpeed !== 0) {
      writer.uint32(69).float(message.maxSpeed);
    }
    if (message.posVelFrame !== 0) {
      writer.uint32(72).sint32(message.posVelFrame);
    }
    if (message.heading !== 0) {
      writer.uint32(85).float(message.heading);
    }
    if (message.headingSmoothness !== 0) {
      writer.uint32(93).float(message.headingSmoothness);
    }
    if (message.headingAggressiveness !== 0) {
      writer.uint32(101).float(message.headingAggressiveness);
    }
    if (message.headingRate !== 0) {
      writer.uint32(109).float(message.headingRate);
    }
    if (message.headingRateAggressiveness !== 0) {
      writer.uint32(117).float(message.headingRateAggressiveness);
    }
    if (message.maxHeadingRate !== 0) {
      writer.uint32(125).float(message.maxHeadingRate);
    }
    if (message.gimbalPitch !== 0) {
      writer.uint32(133).float(message.gimbalPitch);
    }
    if (message.gimbalPitchSmoothness !== 0) {
      writer.uint32(141).float(message.gimbalPitchSmoothness);
    }
    if (message.gimbalPitchAggressiveness !== 0) {
      writer.uint32(149).float(message.gimbalPitchAggressiveness);
    }
    if (message.gimbalPitchRate !== 0) {
      writer.uint32(157).float(message.gimbalPitchRate);
    }
    if (message.gimbalPitchRateAggressiveness !== 0) {
      writer.uint32(165).float(message.gimbalPitchRateAggressiveness);
    }
    if (message.maxGimbalPitchRate !== 0) {
      writer.uint32(173).float(message.maxGimbalPitchRate);
    }
    if (message.gimbalRollCommand !== undefined) {
      GimbalRollCommand.encode(message.gimbalRollCommand, writer.uint32(178).fork()).ldelim();
    }
    if (message.enforceLookatSmoothness === true) {
      writer.uint32(184).bool(message.enforceLookatSmoothness);
    }
    if (message.height !== 0) {
      writer.uint32(197).float(message.height);
    }
    if (message.heightAggressiveness !== 0) {
      writer.uint32(205).float(message.heightAggressiveness);
    }
    if (message.spatialWaypointsEnable === true) {
      writer.uint32(208).bool(message.spatialWaypointsEnable);
    }
    if (message.spatialWaypointsCommand !== undefined) {
      SpatialWaypointsCommand.encode(message.spatialWaypointsCommand, writer.uint32(218).fork()).ldelim();
    }
    if (message.overridePrecisionFlight === true) {
      writer.uint32(224).bool(message.overridePrecisionFlight);
    }
    if (message.gimbalOrientationMode !== 0) {
      writer.uint32(232).int32(message.gimbalOrientationMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Movement {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMovement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.source = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.sourceUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.position = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.positionAggressiveness = reader.float();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.velocity = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.velocityAggressiveness = reader.float();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.maxSpeed = reader.float();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.posVelFrame = reader.sint32();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.heading = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.headingSmoothness = reader.float();
          continue;
        case 12:
          if (tag !== 101) {
            break;
          }

          message.headingAggressiveness = reader.float();
          continue;
        case 13:
          if (tag !== 109) {
            break;
          }

          message.headingRate = reader.float();
          continue;
        case 14:
          if (tag !== 117) {
            break;
          }

          message.headingRateAggressiveness = reader.float();
          continue;
        case 15:
          if (tag !== 125) {
            break;
          }

          message.maxHeadingRate = reader.float();
          continue;
        case 16:
          if (tag !== 133) {
            break;
          }

          message.gimbalPitch = reader.float();
          continue;
        case 17:
          if (tag !== 141) {
            break;
          }

          message.gimbalPitchSmoothness = reader.float();
          continue;
        case 18:
          if (tag !== 149) {
            break;
          }

          message.gimbalPitchAggressiveness = reader.float();
          continue;
        case 19:
          if (tag !== 157) {
            break;
          }

          message.gimbalPitchRate = reader.float();
          continue;
        case 20:
          if (tag !== 165) {
            break;
          }

          message.gimbalPitchRateAggressiveness = reader.float();
          continue;
        case 21:
          if (tag !== 173) {
            break;
          }

          message.maxGimbalPitchRate = reader.float();
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.gimbalRollCommand = GimbalRollCommand.decode(reader, reader.uint32());
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.enforceLookatSmoothness = reader.bool();
          continue;
        case 24:
          if (tag !== 197) {
            break;
          }

          message.height = reader.float();
          continue;
        case 25:
          if (tag !== 205) {
            break;
          }

          message.heightAggressiveness = reader.float();
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.spatialWaypointsEnable = reader.bool();
          continue;
        case 27:
          if (tag !== 218) {
            break;
          }

          message.spatialWaypointsCommand = SpatialWaypointsCommand.decode(reader, reader.uint32());
          continue;
        case 28:
          if (tag !== 224) {
            break;
          }

          message.overridePrecisionFlight = reader.bool();
          continue;
        case 29:
          if (tag !== 232) {
            break;
          }

          message.gimbalOrientationMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Movement {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      source: isSet(object.source) ? movementCommandSource_EnumFromJSON(object.source) : 0,
      sourceUtime: isSet(object.sourceUtime) ? globalThis.Number(object.sourceUtime) : 0,
      position: isSet(object.position) ? Vector3dPb.fromJSON(object.position) : undefined,
      positionAggressiveness: isSet(object.positionAggressiveness)
        ? globalThis.Number(object.positionAggressiveness)
        : 0,
      velocity: isSet(object.velocity) ? Vector3dPb.fromJSON(object.velocity) : undefined,
      velocityAggressiveness: isSet(object.velocityAggressiveness)
        ? globalThis.Number(object.velocityAggressiveness)
        : 0,
      maxSpeed: isSet(object.maxSpeed) ? globalThis.Number(object.maxSpeed) : 0,
      posVelFrame: isSet(object.posVelFrame) ? globalThis.Number(object.posVelFrame) : 0,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      headingSmoothness: isSet(object.headingSmoothness) ? globalThis.Number(object.headingSmoothness) : 0,
      headingAggressiveness: isSet(object.headingAggressiveness) ? globalThis.Number(object.headingAggressiveness) : 0,
      headingRate: isSet(object.headingRate) ? globalThis.Number(object.headingRate) : 0,
      headingRateAggressiveness: isSet(object.headingRateAggressiveness)
        ? globalThis.Number(object.headingRateAggressiveness)
        : 0,
      maxHeadingRate: isSet(object.maxHeadingRate) ? globalThis.Number(object.maxHeadingRate) : 0,
      gimbalPitch: isSet(object.gimbalPitch) ? globalThis.Number(object.gimbalPitch) : 0,
      gimbalPitchSmoothness: isSet(object.gimbalPitchSmoothness) ? globalThis.Number(object.gimbalPitchSmoothness) : 0,
      gimbalPitchAggressiveness: isSet(object.gimbalPitchAggressiveness)
        ? globalThis.Number(object.gimbalPitchAggressiveness)
        : 0,
      gimbalPitchRate: isSet(object.gimbalPitchRate) ? globalThis.Number(object.gimbalPitchRate) : 0,
      gimbalPitchRateAggressiveness: isSet(object.gimbalPitchRateAggressiveness)
        ? globalThis.Number(object.gimbalPitchRateAggressiveness)
        : 0,
      maxGimbalPitchRate: isSet(object.maxGimbalPitchRate) ? globalThis.Number(object.maxGimbalPitchRate) : 0,
      gimbalRollCommand: isSet(object.gimbalRollCommand)
        ? GimbalRollCommand.fromJSON(object.gimbalRollCommand)
        : undefined,
      enforceLookatSmoothness: isSet(object.enforceLookatSmoothness)
        ? globalThis.Boolean(object.enforceLookatSmoothness)
        : false,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      heightAggressiveness: isSet(object.heightAggressiveness) ? globalThis.Number(object.heightAggressiveness) : 0,
      spatialWaypointsEnable: isSet(object.spatialWaypointsEnable)
        ? globalThis.Boolean(object.spatialWaypointsEnable)
        : false,
      spatialWaypointsCommand: isSet(object.spatialWaypointsCommand)
        ? SpatialWaypointsCommand.fromJSON(object.spatialWaypointsCommand)
        : undefined,
      overridePrecisionFlight: isSet(object.overridePrecisionFlight)
        ? globalThis.Boolean(object.overridePrecisionFlight)
        : false,
      gimbalOrientationMode: isSet(object.gimbalOrientationMode)
        ? gimbalOrientationMode_EnumFromJSON(object.gimbalOrientationMode)
        : 0,
    };
  },

  toJSON(message: Movement): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.source !== 0) {
      obj.source = movementCommandSource_EnumToJSON(message.source);
    }
    if (message.sourceUtime !== 0) {
      obj.sourceUtime = Math.round(message.sourceUtime);
    }
    if (message.position !== undefined) {
      obj.position = Vector3dPb.toJSON(message.position);
    }
    if (message.positionAggressiveness !== 0) {
      obj.positionAggressiveness = message.positionAggressiveness;
    }
    if (message.velocity !== undefined) {
      obj.velocity = Vector3dPb.toJSON(message.velocity);
    }
    if (message.velocityAggressiveness !== 0) {
      obj.velocityAggressiveness = message.velocityAggressiveness;
    }
    if (message.maxSpeed !== 0) {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.posVelFrame !== 0) {
      obj.posVelFrame = Math.round(message.posVelFrame);
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.headingSmoothness !== 0) {
      obj.headingSmoothness = message.headingSmoothness;
    }
    if (message.headingAggressiveness !== 0) {
      obj.headingAggressiveness = message.headingAggressiveness;
    }
    if (message.headingRate !== 0) {
      obj.headingRate = message.headingRate;
    }
    if (message.headingRateAggressiveness !== 0) {
      obj.headingRateAggressiveness = message.headingRateAggressiveness;
    }
    if (message.maxHeadingRate !== 0) {
      obj.maxHeadingRate = message.maxHeadingRate;
    }
    if (message.gimbalPitch !== 0) {
      obj.gimbalPitch = message.gimbalPitch;
    }
    if (message.gimbalPitchSmoothness !== 0) {
      obj.gimbalPitchSmoothness = message.gimbalPitchSmoothness;
    }
    if (message.gimbalPitchAggressiveness !== 0) {
      obj.gimbalPitchAggressiveness = message.gimbalPitchAggressiveness;
    }
    if (message.gimbalPitchRate !== 0) {
      obj.gimbalPitchRate = message.gimbalPitchRate;
    }
    if (message.gimbalPitchRateAggressiveness !== 0) {
      obj.gimbalPitchRateAggressiveness = message.gimbalPitchRateAggressiveness;
    }
    if (message.maxGimbalPitchRate !== 0) {
      obj.maxGimbalPitchRate = message.maxGimbalPitchRate;
    }
    if (message.gimbalRollCommand !== undefined) {
      obj.gimbalRollCommand = GimbalRollCommand.toJSON(message.gimbalRollCommand);
    }
    if (message.enforceLookatSmoothness === true) {
      obj.enforceLookatSmoothness = message.enforceLookatSmoothness;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.heightAggressiveness !== 0) {
      obj.heightAggressiveness = message.heightAggressiveness;
    }
    if (message.spatialWaypointsEnable === true) {
      obj.spatialWaypointsEnable = message.spatialWaypointsEnable;
    }
    if (message.spatialWaypointsCommand !== undefined) {
      obj.spatialWaypointsCommand = SpatialWaypointsCommand.toJSON(message.spatialWaypointsCommand);
    }
    if (message.overridePrecisionFlight === true) {
      obj.overridePrecisionFlight = message.overridePrecisionFlight;
    }
    if (message.gimbalOrientationMode !== 0) {
      obj.gimbalOrientationMode = gimbalOrientationMode_EnumToJSON(message.gimbalOrientationMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Movement>, I>>(base?: I): Movement {
    return Movement.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Movement>, I>>(object: I): Movement {
    const message = createBaseMovement();
    message.utime = object.utime ?? 0;
    message.source = object.source ?? 0;
    message.sourceUtime = object.sourceUtime ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? Vector3dPb.fromPartial(object.position)
      : undefined;
    message.positionAggressiveness = object.positionAggressiveness ?? 0;
    message.velocity = (object.velocity !== undefined && object.velocity !== null)
      ? Vector3dPb.fromPartial(object.velocity)
      : undefined;
    message.velocityAggressiveness = object.velocityAggressiveness ?? 0;
    message.maxSpeed = object.maxSpeed ?? 0;
    message.posVelFrame = object.posVelFrame ?? 0;
    message.heading = object.heading ?? 0;
    message.headingSmoothness = object.headingSmoothness ?? 0;
    message.headingAggressiveness = object.headingAggressiveness ?? 0;
    message.headingRate = object.headingRate ?? 0;
    message.headingRateAggressiveness = object.headingRateAggressiveness ?? 0;
    message.maxHeadingRate = object.maxHeadingRate ?? 0;
    message.gimbalPitch = object.gimbalPitch ?? 0;
    message.gimbalPitchSmoothness = object.gimbalPitchSmoothness ?? 0;
    message.gimbalPitchAggressiveness = object.gimbalPitchAggressiveness ?? 0;
    message.gimbalPitchRate = object.gimbalPitchRate ?? 0;
    message.gimbalPitchRateAggressiveness = object.gimbalPitchRateAggressiveness ?? 0;
    message.maxGimbalPitchRate = object.maxGimbalPitchRate ?? 0;
    message.gimbalRollCommand = (object.gimbalRollCommand !== undefined && object.gimbalRollCommand !== null)
      ? GimbalRollCommand.fromPartial(object.gimbalRollCommand)
      : undefined;
    message.enforceLookatSmoothness = object.enforceLookatSmoothness ?? false;
    message.height = object.height ?? 0;
    message.heightAggressiveness = object.heightAggressiveness ?? 0;
    message.spatialWaypointsEnable = object.spatialWaypointsEnable ?? false;
    message.spatialWaypointsCommand =
      (object.spatialWaypointsCommand !== undefined && object.spatialWaypointsCommand !== null)
        ? SpatialWaypointsCommand.fromPartial(object.spatialWaypointsCommand)
        : undefined;
    message.overridePrecisionFlight = object.overridePrecisionFlight ?? false;
    message.gimbalOrientationMode = object.gimbalOrientationMode ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
